import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { TbView360Arrow } from "react-icons/tb";
import "./VirtualTour.css";

export default function VirtualTour(props) {
  return (
    <Container>
      <Row>
        <Col className="virtual-tour-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <TbView360Arrow
              style={{ color: props.iconColor }}
              className="virtual-tour-icon"
            />
            NOSSA ESTRUTURA TOUR VIRTUAL
          </h2>
        </Col>
      </Row>
      <Row>
        <Col className="virtual-tour-second-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            {props.subTextContent}
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="virtual-tour-third-col">{props.mapFrame}</Col>
      </Row>
    </Container>
  );
}
